import { useWoody } from '../../woody/woody.js';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { resourceDetailsQueryKeys } from './resourceDetailsQueryKeys.js';
import { useSocketIOParentRoomEventListener } from '../../socket.io/ParentRoom/useSocketIOParentRoomEventListener.js';

const useQueryResourceAssets = ({ resourceId }, options) => {
  const { client } = useWoody();
  const query = useQuery({
    queryKey: resourceDetailsQueryKeys.assets(resourceId),
    queryFn: async () => {
      const response = await client.v2({
        endpoint: "/v2/resources/{resourceId}/assets",
        params: {
          resourceId
        }
      }, {
        method: "get",
        query: {
          limit: 100
        }
      });
      return response;
    },
    placeholderData: keepPreviousData,
    ...options
  });
  useSocketIOParentRoomEventListener("RESOURCES:RELOAD", () => {
    query.refetch();
  });
  return query;
};

export { useQueryResourceAssets };
//# sourceMappingURL=useQueryResourceAssets.js.map
